<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-8 col-6">
              <h2>Manage Users</h2>
            </div>
            <div class="col-lg-4 col-6 text-right bid">
              <button @click="openAddUserPopup()" type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW USER</button>
               <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                  <i @click="searchUser()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                  <input v-on:keyup.enter="searchUser" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search User" aria-label="Search">
                  <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                </form>              
            </div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <div class="card vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                      @click="sort('firstName')" >User</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'email'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'email'  ? 'sort-desc' : '']"  
                      @click="sort('email')">Email</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'phone'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'phone'  ? 'sort-desc' : '']"  
                      @click="sort('phone')">Phone</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'address'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'address'  ? 'sort-desc' : '']"  
                      @click="sort('address')">Location</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'createdAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'createdAt'  ? 'sort-desc' : '']"  
                      @click="sort('createdAt')">Created Date</th>
                    <th 
                      scope="col" 
                      class="sort"
                     >Roles</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']" 
                      @click="sort('status')" >Status</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'mfaActive'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'mfaActive'  ? 'sort-desc' : '']" 
                      @click="sort('mfaActive')" >MFA Status</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'positionText'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'positionText'  ? 'sort-desc' : '']"  
                      @click="sort('positionText')"
                    >Position</th>

                    <th scope="col" class="sort text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p>
                    </td>
                  </tr>
                  <tr v-for="user in users" :key="user.Username">
                    <td >{{user.firstname ? user.firstName[0] : ''}}. {{user.lastName}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.phone}}</td>
                    <td>{{user.address}}</td>
                    <td>{{moment(user.createdAt).format("MM/DD/YYYY")}}</td>
                    <td><span class="badge">{{getUserGroupNames(user.userGroups)}}</span></td>
                    <td class="text-center">
                      <span class="badge" v-bind:class="user.status == 'ACTIVE' ? 'active' : 'deactive'">{{user.status == 'DEACTIVE' ? 'INACTIVE' : user.status}}</span>
                    </td>
                    <td class="text-center">
                      <toggle-button :sync="true" v-model="user.mfaActive" @change="onChangeEventHandler(user.mfaActive,user.cognitoSub)"/>
                    </td>
                    <td>
                      <span class=" text-wrap">{{user.positionText}}</span>
                    </td>

                    <td class="text-center">
                      <a 
                        data-toggle="tooltip" 
                        title="Edit User"  
                        style="display:inline-block" 
                        @click="openEditUserPopup(user)"  
                        v-bind:class="[ getUserGroupNames(user.userGroups).includes('SuperAdmin') && !isSuperAdmin  ? 'disabled' : '']"  >
                        <span class="btn-icon">
                          <i class="fas fa-user-edit"></i>
                        </span>
                      </a>
                       <a 
                        data-toggle="tooltip" 
                        title="Send password reset email"  
                        style="display:inline-block" 
                        @click="sendPasswordResetEmail(user)" >
                        <span class="btn-icon" style="background-color: #FF9E47;color: white;">
                          <i class="fas fa-envelope"></i>
                        </span>
                      </a>
                      <a  href="#"
                      data-toggle="modal"
                      data-target="#change-userstatus" class="btn-width">
                        <button 
                          v-if="user.status == 'ACTIVE'" 
                          @click="selectedUser = user" 
                          type="button" 
                          :disabled="getUserGroupNames(user.userGroups).includes('SuperAdmin') && !isSuperAdmin"
                          class="btn btn-danger btn-sm my-2"><i class="fas fa-ban"></i> DEACTIVATE</button>
                        <button 
                          v-if="user.status == 'DEACTIVE'"  
                          @click="selectedUser = user" 
                          type="button" 
                          :disabled="getUserGroupNames(user.userGroups).includes('SuperAdmin') && !isSuperAdmin"
                          class="btn btn-success btn-sm my-2"><i class="fas fa-check"></i> ACTIVATE</button>
                      </a>
                      <!-- <a>
                        <span class="btn-icon">
                          <i class="fas fa-user-edit"></i>
                        </span>
                      </a> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getUserList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <!-- Modal ADD OR EDIT  -->
      <div
        class="modal fade"
        id="adduser"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{userEditFlag ? 'EDIT USER'  : 'ADD USER'}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
             <form>
               <div class="form-row">
                  <div class="form-group col-md-6 required">
                    <label for="inputEmail4 ">First Name</label>
                    <input type="text" class="form-control" id="inputEmail4" v-model="userObj.firstName">
                  </div>
                  <div class="form-group col-md-6 required">
                    <label for="inputPassword4">Last Name</label>
                    <input type="text" class="form-control" id="inputPassword4" v-model="userObj.lastName">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6 required">
                    <label for="inputEmail4">Phone Number</label>
                    <vue-phone-number-input 
                    name="phone" 
                    v-model="userObj.phone"
                     :no-country-selector="true"
                     default-country="US"
                    @update="phoneNumberChanged" />
                    <!-- <input type="text" @input="acceptNumber" class="form-control" id="inputEmail4" v-model="userObj.phone"> -->
                  </div>
                  <div class="form-group col-md-6 required">
                    <label for="inputPassword4">Location</label>
                    <select class="form-control" v-model="userObj.address">
                      <option value="">Please select</option>
                      <option value="Remote">Remote</option>
                      <option value="Office">Office</option>
                    </select>
                  </div>
                </div>
               <div class="form-row">
                 <div class="form-group col-md-6 required">
                  <label for="inputAddress">Email</label>
                  <input :disabled="userEditFlag" type="email" class="form-control" id="inputAddress" v-model="userObj.email" >
                  <small id="emailHelp" class="form-text text-muted"><i class="fas fa-info-circle"></i> User can login using this Email Address</small>
                </div>
                <div  class="form-group col-md-6 required">
                  <label class="typo__label">User Roles</label>
                  <multiselect v-model="value" placeholder="Select role" label="name" @input="removeDuplicates" track-by="code" :options="options" :multiple="true" ></multiselect>
      
                </div>
                <div  class="form-group col-md-6">
                  <label class="typo__label">Position</label>
                  <input  type="text" class="form-control" id="positiontext" v-model="userObj.positionText" >
      
                </div>
                </div>
              </form>
            </div>

            <div class="modal-footer bid">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button v-if="!userEditFlag" type="button" class="btn btn-primary" @click="createUser(userObj)">Add</button>
              <button v-if="userEditFlag"  type="button" class="btn btn-primary" @click="updateUser(userObj)">Update</button>
            </div>
            <div v-if="userLoadingFlag" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>

            <div class="alert alert-danger" role="alert" v-if="error">{{error}}</div>

          </div>
        </div>
      </div>
      <!-- Change user status -->
      <div
        class="modal fade"
        id="change-userstatus"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h3>Are you sure you want to {{selectedUser.status == 'DEACTIVE' ? "activate" : "deactivate"}} this user?</h3>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">CANCEL</button>
              <button type="button" class="btn btn-danger" @click="changeUserStatus(selectedUser)" >CONFIRM</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import cognitoService from '@/cognito/cognitoidentityserviceprovider.js';
import config from "@/config";
import authService from "@/authService";
export default {
  name: "users",
  components: {
    // Header,
    // Footer
  
  },
  data() {
    return {
      accessToken: null,
      users: [],
      userObj : {location:""},
      config: config,
      cognitoService: cognitoService,
      loading : false,
      cognitoidentityserviceprovider : {},
      value: [],
      options: [
        { name: 'Trader', code: 'Trader' },
        { name: 'Admin', code: 'Admin' },
        { name: 'Editor', code: 'Editor' },
        { name: 'Operator', code: 'Operator' },
        { name: 'Guest', code: 'Guest' },
        // { name: 'Client', code: 'Client' },
        { name: 'Rep', code: 'Rep' },
        { name: 'CapitalRiskManager', code: 'CapitalRiskManager' }

         


      ],
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 0,
      sortColumn: "firstName",
      sortOrder: "ASC",
      group:"",
      error: null,
      userEditFlag: false,
      tenantName : null,
      userLoadingFlag : false,
      isSuperAdmin : false,
      roleArray : [],
      selectedUser : {},
      formattedNumber : null,
      idToken : null



    };
  },
  created() {
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.tenantName = role[0].split("-")[0];
        this.roleArray = role.map(item => {return  item.split("-")[1]});
        this.roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;

      }
    });
  },
  methods: {
  sendPasswordResetEmail(user){
    var message = "Are you sure you want to send password reset email to the "+user.firstName+" "+user.lastName+" ("+user.email+")?";
    this.$confirm(message,"","question").then(() => {
         let dataToSend = {"email": user.email , "resetByUserId": authService.getUser().id}
    const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http.put(config.baseUrlAutoBidder +"/user/reset-pwd",dataToSend,auth)
      .then(() => {
          this.$alert("Password reset email sent successfully.","","success");
      }).catch(() => {
          this.$alert("Something went wrong.","","error");
      });
    }).catch(() => {
        //console.log("cancelled")
    });
   
  },
  
    onChangeEventHandler(UserStatus,cognitoSub){
      let message = "MFA "+(UserStatus ? "activated" : "deactivated")+ " for this user";
      let userData = {
          "cognitoSub": cognitoSub,
          "accessToken": this.idToken,
          "softwareTokenMfaSettings": {
              "enabled": UserStatus,
              "preferredMfa": UserStatus
          },
          "sMSMfaSettings": {
              "enabled": false,
              "preferredMfa": false
          }
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlBidSide + "/user/mfa-enable ",
          userData,
          auth
        )
        .then(() => {
          this.$alert(message,"","success")
        }).catch(() => {
          this.$alert("Something went wrong.","","error");
          window.location.reload()
        });
    },
    phoneNumberChanged(obj){
      console.log("updated",obj)
      this.formattedNumber  = obj.isValid ? obj.formattedNumber : null
    },
    acceptNumber() {
      /* eslint-disable no-mixed-spaces-and-tabs */
    	var x = this.userObj.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.userObj.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    
    },
    removeDuplicates(data){
      this.value = data.filter((role, index, self) =>
        index === self.findIndex((t) => (
          t.code === role.code && t.name === role.name
        ))
      )
    },
    clearSearch(){
      this.searchValue = "";
      this.getUserList(); 
    },
    searchUser(){
      this.getUserList();
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getUserList();
    },
    getUserList(currentPage){
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      //console.log(auth);
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&group=" +
            this.group ,
            auth
        )
        .then(result => {
          console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          this.users = result.data.content;
          this.loading = false;
          
        })
        .catch(e => {
          console.log(e);
        });
    },
    openAddUserPopup(){
      this.userObj = {location:""};
      this.value = [];
      this.userEditFlag = false;
      this.error = false;
      window.$('#adduser').modal("show");
    },
    createUser(user){
      this.error = false;
      if (!user.firstName) {
        this.error = "First name is required";
        return false;
      }
      if (!user.lastName) {
        this.error = "Last name is required";
        return false;
      }
      if (!user.phone) {
        this.error = "Phone number is required";
        return false;
      }
       if (user.phone.match(/\d/g).length != 10) {
        this.error = "Phone number should be 10 digits";
        return false;
      }
      if (!user.address) {
        this.error = "Location is required";
        return false;
      }
      if (!user.email) {
        this.error = "Email is required";
        return false;
      }
      if(!this.validateEmail(user.email)){
        this.error = "You have entered an invalid email address!";
        return false;
      }
      if (this.value.length ==  0) {
        this.error = "User role is required";
        return false;
      }
      if (this.formattedNumber == null) {
        this.error = "Invalid phone number";
        return false;
      }
      
      this.userLoadingFlag = true;
       let dataToSend = {...user};
      dataToSend.phone = this.formattedNumber;
      dataToSend.userType = 'USER';
      dataToSend.createdBy = authService.getUser().id

      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlBidSide + "/user",
          dataToSend,
          auth
        )
        .then(response => {
         // console.log(response);
          this.error = false;
          this.addRole(response.data.id);
          // this.setUserLastPasswordReset(user.email);
          //this.$alert("User Added");
          //this.getUserList()
        })
        .catch(e => {
          this.$alert(e.response.data);
          this.userLoadingFlag = false;
        });
    },
    setUserLastPasswordReset(email){
      let dataToSend = {"userName": email}
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http.put(config.baseUrlAutoBidder +"/user/resetPwd",dataToSend,auth)
      .then(() => {
                              
      })

    },
    openEditUserPopup(user){

      // Check logged user is superAdmin to edit a super admin user
      if(this.getUserGroupNames(user.userGroups).includes('SuperAdmin') && !this.isSuperAdmin){
        return false;
      }
     // if(this.getUserGroupNames(user.userGroups).includes('RiskManager') && !this.isSuperAdmin){
      //  return false;
      //}
      this.userObj = {...user};
      this.formattedNumber = user.phone;
      this.userEditFlag = true;
      this.error = false;
      this.value = [];
      this.value = user.userGroups.map((role) =>{
        return {name : role.split('-')[1] , code : role.split('-')[1]}
      })
      window.$('#adduser').modal("show");
    },
    updateUser(user){
      this.error = false;
      if (!user.firstName) {
        this.error = "First name is required";
        return false;
      }
      if (!user.lastName) {
        this.error = "Last name is required";
        return false;
      }
      if (!user.phone) {
        this.error = "Phone Number is required";
        return false;
      }
      if (!user.address) {
        this.error = "Location is required";
        return false;
      }
      if (!user.email) {
        this.error = "Email is required";
        return false;
      }
      if(!this.validateEmail(user.email)){
        this.error = "You have entered an invalid email address!";
        return false;
      }
      if (this.value.length ==  0) {
        this.error = "User Role is required";
        return false;
      }
      if (this.formattedNumber == null) {
        this.error = "Invalid phone number";
        return false;
      }
      this.userLoadingFlag = true;
      let dataToSend = {...user};
      dataToSend.phone = this.formattedNumber;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/user",
          dataToSend,
          auth
        )
        .then(() => {
          this.updateRole(user.id);
          //this.userLogOut(user.id);
        })
        .catch(e => {
          console.log(e);
        });
    },
    addRole(userId){
      var roleObj = {
            "userId": userId,
            "groups":  this.value.map((role) => {return this.tenantName+'-'+role.name})
        }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlBidSide + "/user/groups",
          roleObj,
          auth
        )
        .then(() => {
          this.$alert(this.appMessages.addUser);
          this.getUserList();
          window.$('#adduser').modal("hide");
          this.userEditFlag = false;
          this.userLoadingFlag = false;

        })
        .catch(e => {
          console.log(e);
        });
    },
    updateRole(userId){
      var roleObj = {
            "userId": userId,
            "groups":  this.value.map((role) => {return this.tenantName+'-'+role.name})
        }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.userFlag = true;
      this.$http
        .put(
          config.baseUrlBidSide + "/user/groups",
          roleObj,
          auth
        )
        .then(() => {
          this.$alert(this.appMessages.updateUser,"","success");
          this.getUserList();
          window.$('#adduser').modal("hide");
          this.userEditFlag = false;
          this.userLoadingFlag = false;

        })
        .catch(e => {
          console.log(e);
        });

    },
    userLogOut(userId){
      var user = {
            "id": userId
        }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.userFlag = true;
      this.$http
        .put(
          config.baseUrlBidSide + "/user/logout",
          user,
          auth
        )
        .then(() => {
        })
        .catch(e => {
          console.log(e);
        });

    },
    getUserGroupNames(group){
      var removedTenantName = group.map((groupName) => {
        return groupName.split('-')[1]
      });
      return removedTenantName.join(', ');
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    changeUserStatus(user){
       var userObj = {
            "id": user.id,
            "status":  user.status == 'DEACTIVE' ? "ACTIVE" : "DEACTIVE"
        }

        console.log(userObj)
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.userFlag = true;
      this.$http
        .put(
          config.baseUrlBidSide + "/user/status",
          userObj,
          auth
        )
        .then(() => {
          this.getUserList();
          window.$('#change-userstatus').modal("hide");


        })
        .catch(e => {
          console.log(e);
          window.$('#change-userstatus').modal("hide");

        });
    }

  },
  mounted() {

    this.group = this.$route.query.group ? this.$route.query.group : "";
    // this.$cognitoAuth.getIdToken((err, result) => {
    //   if (err) {
    //     this.error = err;
    //   } else {
    //     this.accessToken = result;
    //     this.getUserList();

    //   }
    // });
    this.$cognitoAuth.isAuthenticated((session) => {
            this.idToken = session.accessToken.jwtToken;
            this.accessToken = session.getIdToken().getJwtToken();
            this.getUserList();
        })   
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          if(roleArray.includes('SuperAdmin')){
             this.options.push({ name: 'SuperAdmin', code: 'SuperAdmin'})
             this.options.push({ name: 'RiskManager', code: 'RiskManager'})
          }
        }
        //console.log("isa",this.isAdmin);
      });

  }
};
</script>
<style scoped>
</style>